(function () {
  'use strict';

  var STORAGE_KEY = 'premium_cart_timer_end';

  function isFreeShippingUnlocked(timer) {
    var card = timer.closest('.premium-cart-bar-card');
    if (!card) return false;
    var bar = card.querySelector('free-ship-progress-bar');
    return !!(bar && bar.classList.contains('cart_shipping_free'));
  }

  function clearEmptyCartTimer() {
    if (!document.querySelector('.cart-item, .ci-card')) {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  }

  function getEndTimestamp(durationMin) {
    var stored = sessionStorage.getItem(STORAGE_KEY);
    var endTimestamp = stored ? parseInt(stored, 10) : 0;
    var now = Date.now();

    if (!endTimestamp || endTimestamp <= now) {
      endTimestamp = now + durationMin * 60 * 1000;
      sessionStorage.setItem(STORAGE_KEY, String(endTimestamp));
    }

    return endTimestamp;
  }

  if (!customElements.get('premium-cart-timer')) {
    class PremiumCartTimer extends HTMLElement {
      connectedCallback() {
        this.ensureRunning();
      }

      disconnectedCallback() {
        this.stop();
      }

      stop() {
        if (this.animationFrameId) {
          cancelAnimationFrame(this.animationFrameId);
          this.animationFrameId = null;
        }
      }

      ensureRunning() {
        if (isFreeShippingUnlocked(this)) {
          this.stop();
          this.hidden = true;
          return;
        }

        this.hidden = false;
        this.minEl = this.querySelector('.premium-timer-minute');
        this.secEl = this.querySelector('.premium-timer-sec');
        this.msEl = this.querySelector('.premium-timer-ms');

        if (!this.minEl || !this.secEl || !this.msEl) return;

        if (this.animationFrameId) return;

        var durationMin = parseFloat(this.dataset.countdownTime) || 5;
        this.endTimestamp = getEndTimestamp(durationMin);
        this.tick();
      }

      tick() {
        if (this.hidden || isFreeShippingUnlocked(this)) {
          this.stop();
          this.hidden = true;
          return;
        }

        var remaining = this.endTimestamp - Date.now();

        if (remaining <= 0) {
          this.minEl.textContent = '00';
          this.secEl.textContent = '00';
          this.msEl.textContent = '00';

          var card = this.closest('.premium-cart-bar-card');
          if (card) card.classList.add('premium-timer-expired');

          sessionStorage.removeItem(STORAGE_KEY);
          this.stop();
          return;
        }

        var minutes = Math.floor(remaining / 60000);
        var seconds = Math.floor((remaining % 60000) / 1000);
        var milliseconds = Math.floor((remaining % 1000) / 10);

        this.minEl.textContent = String(minutes).padStart(2, '0');
        this.secEl.textContent = String(seconds).padStart(2, '0');
        this.msEl.textContent = String(milliseconds).padStart(2, '0');

        this.animationFrameId = requestAnimationFrame(this.tick.bind(this));
      }
    }

    customElements.define('premium-cart-timer', PremiumCartTimer);
  }

  function refreshPremiumCartBarFromSection(sectionHtml, subtotalPrice) {
    if (!sectionHtml) return;

    var html =
      typeof sectionHtml === 'string'
        ? new DOMParser().parseFromString(sectionHtml, 'text/html')
        : sectionHtml;

    var source = html.querySelector('#premium-cart-bar-slot');
    var target = document.querySelector('#premium-cart-bar-slot');
    if (!source || !target) return;

    target.innerHTML = source.innerHTML;

    var bar = target.querySelector('free-ship-progress-bar');
    if (bar && subtotalPrice != null) {
      bar.init(subtotalPrice);
    }

    document.querySelectorAll('#premium-cart-bar-slot premium-cart-timer').forEach(function (timer) {
      if (typeof timer.ensureRunning === 'function') {
        timer.ensureRunning();
      }
    });
  }

  window.PremiumCartTimer = {
    ensureRunning: function () {
      document.querySelectorAll('premium-cart-timer').forEach(function (timer) {
        if (typeof timer.ensureRunning === 'function') {
          timer.ensureRunning();
        }
      });
    },
  };

  window.refreshPremiumCartBarFromSection = refreshPremiumCartBarFromSection;

  document.addEventListener('DOMContentLoaded', function () {
    clearEmptyCartTimer();
    window.PremiumCartTimer.ensureRunning();

    var wrapper = document.querySelector('.bls-minicart-wrapper');
    if (wrapper) {
      new MutationObserver(clearEmptyCartTimer).observe(wrapper, {
        childList: true,
        subtree: true,
      });
    }
  });
})();
